import React from "react";
import StudentLayout from "../Layout";
import { AssignmentsTable } from "../Components/AssignmentsTable";
import {
  useGetAssignmentQuery,
  useGetAssignmentLeaderBoardQuery,
  useGetCampusQuery,
  useGetStudentByEmailIdQuery,
} from "../../../graphql/generated.tsx";
import { Table, Alert } from "flowbite-react";
import { SkeletonRow } from "../Components/LeaderBoardSkeleton.jsx";
import { useParams } from "react-router-dom";
import { IoMdArrowRoundBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";

const StudentAssignment = () => {
  const { assignmentId } = useParams();
  const navigate = useNavigate();
  const email = JSON.parse(localStorage.getItem("user"))?.email;

  const {
    data: studentData,
    error: studentError,
  } = useGetStudentByEmailIdQuery({
    variables: { email },
  });

  const studentId = studentData?.getStudentByEmailId?.id;
  const campusId = studentData?.getStudentByEmailId?.campusId;
  const {
    data: campusData,
    error: campusError,
  } = useGetCampusQuery({
    variables: { id: campusId },
    skip: !campusId,
  });

  const campusName = campusData?.campus?.name;
  const { data: leaderboard, loading, error: leaderboardError } = useGetAssignmentLeaderBoardQuery({
    variables: { assignmentId, campus_name: campusName },
    skip: !campusName,
  });
  const { data: AssignmentInfo, error: assignmentError } = useGetAssignmentQuery({
    variables: { id: assignmentId },
  });

  const queryError = studentError || campusError || leaderboardError || assignmentError;
  if (queryError) {
    const errorMessage =
      queryError?.graphQLErrors?.[0]?.message ||
      queryError?.message ||
      "Something went wrong. Please try again later.";
    return (
      <StudentLayout backgroundClass="bg-white">
        <div className="m-10">
          <button
            onClick={() => navigate("/student/assignment-leaderboard")}
            className="text-gray-500 hover:text-gray-700 focus:outline-none mb-4"
          >
            <span className="gap-2 text-sm font-medium flex items-center">
              <IoMdArrowRoundBack className="h-6 w-6" />
              Go Back
            </span>
          </button>
          <Alert color="failure">
            <span>{errorMessage}</span>
          </Alert>
        </div>
      </StudentLayout>
    );
  }

  if (loading) {
    return (
      <StudentLayout backgroundClass="bg-white">
        <div className="overflow-x-auto my-10 bg-white py-5 shadow-sm rounded-lg m-10">
          <Table className="min-w-full text-sm text-left text-gray-500">
            <Table.Head className="bg-white">
              {[
                "Position",
                "Name",
                "Roll No",
                "Points",
                "Questions Attended",
                "Questions Completedasdsd",
                "Batch Enrolled",
                "Progress",
              ].map((heading) => (
                <Table.HeadCell className="py-3 px-6 text-gray-700 bg-white" key={heading}>
                  {heading}
                </Table.HeadCell>
              ))}
            </Table.Head>
            <Table.Body className="bg-white divide-y divide-gray-200">
              {[...Array(5)].map((_, index) => (
                <SkeletonRow col={8} />
              ))}
            </Table.Body>
          </Table>
        </div>
      </StudentLayout>
    );
  }

  return (
    <StudentLayout backgroundClass="bg-white">
      <div className="m-10">
        <button
          onClick={() => navigate("/student/assignment-leaderboard")}
          className="text-gray-500 hover:text-gray-700 focus:outline-none"
        >
          <span className="gap-2 text-sm font-medium flex items-center">
            <IoMdArrowRoundBack className="h-6 w-6" />
            Go Back
          </span>
        </button>
        <AssignmentsTable
          assignmentInfo={AssignmentInfo?.getAssignment}
          assignments={leaderboard?.getAssignmentLeaderBoard}
          assignmentsLoading={loading}
          studentId={studentId}
        />
      </div>
    </StudentLayout>
  );
};

export default StudentAssignment;
